export default "__VITE_ASSET__BDBbhoX___"